import React, { FC } from 'react';
import { Box } from '@chakra-ui/react';
import { CancelListingButton } from '@app/screens/nft-marketplace/CancelListingButton';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { Token } from '@app/types/token';
import { SettleListingButton } from '@app/screens/nft-marketplace/SettleListingButton';
import { BuyNowButton } from '@app/screens/nft-marketplace/BuyNowButton';
import styles from '@app/screens/nft-marketplace/SpNftMarketPlaceList/SpNftMarketPlaceList.module.scss';
import { getToken } from '@app/helpers/token';
import { BidNowButton } from '@app/screens/nft-marketplace/BidNowButton';

interface Props {
  listing: NFTMarketplaceListing;
  sellCurrency: Token;
}

const buttonSxProps = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: '36px',
  width: '100%',
  borderRadius: 0,
  transform: 'translateY(100%)',
  transition: 'all 0.3s ease',
  opacity: 0
};

const buttonHoverProps = {
  opacity: 1,
  transform: 'translateY(0)'
};

export const RewardCardAction: FC<Props> = ({ listing, sellCurrency }) => {
  return (
    <Box
      position="absolute"
      bottom={0}
      left={0}
      width="100%"
      height="36px"
      overflow="hidden"
    >
      <CancelListingButton
        listing={listing}
        sellCurrency={sellCurrency}
        variant="primary"
        sx={buttonSxProps}
        _groupHover={buttonHoverProps}
      />
      <SettleListingButton
        listing={listing}
        sellCurrency={sellCurrency}
        variant="primary"
        sx={buttonSxProps}
        _groupHover={buttonHoverProps}
      />
      {listing.type === 'BUY_IT_NOW' ||
      listing.type === 'BUY_IT_NOW_WITH_BIDS' ? (
        <BuyNowButton
          classes={{ root: styles.buyButtonRoot }}
          listing={listing}
          variant="primary"
          sx={buttonSxProps}
          _groupHover={buttonHoverProps}
          inactiveSxProps={{
            transition: 'none',
            transform: 'none',
            position: 'relative',
            borderRight: '1px solid black',
            borderRadius: '0',
            flex: 1
          }}
          activeSxProps={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            height: '36px',
            width: '100%',
            borderRadius: 0,
            opacity: 1
          }}
        />
      ) : (
        <BidNowButton
          classes={{ root: styles.bidButtonRoot }}
          sellCurrency={sellCurrency}
          listing={listing}
          variant="primary"
          sx={buttonSxProps}
          _groupHover={buttonHoverProps}
          activeSxProps={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            height: '36px',
            width: '100%',
            opacity: 1,
            borderBottom: 0,
            borderRadius: 0,
            border: '0 !important'
          }}
        />
      )}
    </Box>
  );
};
